<template>
  <div
    v-if="isAdmin && isPromoteur"
    class="l-contentmain contentmain">
    <page-nav-bar
      v-if="agence"
      :is-sticky="true"
      :back-button="true"
      :has-actions="!agence.protected">
      <template slot="breadcrumb">
        <h1 class="page-header-breadcrumb-item is-uppercase">
          <router-link :to="{ name: 'AgenceListVue' }">
            Agence
          </router-link>
        </h1>

        <div class="page-header-breadcrumb-separator"></div>
        <div
          class="page-header-breadcrumb-item"
          v-if="agence && agence.name">
          <span class="has-text-weight-normal has-text-grey-dark">{{ agence.name }}</span>
        </div>
      </template>
      <a
        v-if="!agence.protected"
        slot="dropdown-content"
        class="dropdown-item has-background-danger has-text-white"
        @click="removeCanal">
        <span class="icon is-medium"><i class="fas fa-trash-alt"></i></span><span class="is-margin-left-xsmall">Supprimer l'agence</span>
      </a>
    </page-nav-bar>
    <spinner-round
      :is-loading="loading"
      v-if="loading"></spinner-round>
    <page-content
      v-else-if="agence && !loading"
      :has-left-col-small="true"
      :has-left-col-small-size-fixed="true"
      :has-sticky-col-left="true">
      <template slot="left-col-small">
        <div class="has-background-white is-border">
          <div class="is-padding-top is-padding-left is-padding-right is-padding-bottom-small">
            <figure class="image is-128x128 is-margin-auto has-vadPicto has-picto--top2Right">
              <div class="is-border is-border--circle is-clipped">
                <div
                  class="has-text-white is-clipped is-size-1 is-relative has-background-light--darken2 has-text-centered"
                  style="width: 126px; height: 126px; line-height: 140px;">
                  <i class="fas fa-users-class fa-2x"></i>
                </div>
              </div>
            </figure>
            <div
              v-if="agence && agence.name"
              class="title is-3 is-margin-top-xsmall is-marginless-bottom has-text-centered">
              <b>{{ agence.name }}</b>
            </div>
          </div>
          <div class="is-border-top is-border--dashed">
            <div class="columns is-multiline is-gapless">
              <div
                @click="tab === 'MEMBRES'"
                class="column is-6 is-border-bottom is-border-right is-border--dashed columns is-column is-space-between is-padding-top-small is-padding-bottom-small is-padding-left is-padding-right">
                <div class="has-text-grey is-size-6">
                  Membre(s) de l'agence
                </div>
                <div> {{ agence.users.length }} </div>
              </div>
              <div
                v-if="total_access > 0"
                @click="tab === 'MEMBRES'"
                class="column is-6 is-border-bottom is-border-right is-border--dashed columns is-column is-space-between is-padding-top-small is-padding-bottom-small is-padding-left is-padding-right">
                <div class="has-text-grey is-size-6">
                  Programme(s) de l'agence
                </div>
                <div> {{ total_access }} </div>
              </div>
            </div>
          </div>
        </div>
        <event-tracker-list :field="'agence'"></event-tracker-list>
      </template>
      <div class="has-background-white is-border">
        <tabs
          :links="canalTabLinks"
          :current-tab="tab"
          @changeView="tab = $event"
          mode="emitter"
          class="is-border-bottom"></tabs>
        <div
          v-if="tab === 'MEMBRES'"
          class="is-padding">
          <div :class="{'is-paddingless-bottom': agence.users && agence.users.length}">
            <r-label
              :is-required="false"
              :label="'Membre(s) du agence'">
              <span class="tag has-text-weight-normal is-small is-primary is-margin-left-xsmall">{{ agence.users.length }}</span>
            </r-label>
            <div
              class="column is-12 columns is-multiline"
              v-if="agence.users && !agence.users.length">
              <div class="notification is-warning is-radius-large is-padding-small">
                <p class="is-margin-right">
                  <i class="fal fa-comment-alt-exclamation fa-lg is-inline-block is-vcentered is-margin-right-xsmall"></i>
                  <span>Aucun membre dans l'agence<br></span>
                </p>
              </div>
            </div>
            <a
              v-if="!agence.protected"
              @click.prevent.stop="openAddNewMember"
              class="columns is-vcentered is-gapless is-border is-padding-small has-link-grey">
              <div class="column">
                <div class="is-uppercase">
                  <avatar
                    :force-picto="true"
                    :use-picto-custom="'fal fa-user-plus'"
                    :is-avatar="false"
                    class="is-border is-medium"></avatar>
                  <span class="is-margin-left-small">Ajouter un Membre</span>
                </div>
              </div>
            </a>
          </div>
          <div
            class="is-padding-top"
            v-if="agence.users && agence.users.length">
            <div
              class="columns is-vcentered is-gapless is-border is-padding-small"
              v-for="(user, i) in users"
              :key="user.pk">
              <div class="column columns is-gapless">
                <div class="column is-vcentered columns">
                  <avatar
                    :item="user"
                    :i="i"
                    class="is-medium"></avatar>
                  <div
                    class="is-margin-left-small">
                    <div class="title is-3">
                      <router-link :to="{name: 'UserVue', params: {id: user.pk}}">
                        <span class="is-size-4 has-text-weight-normal">{{ user.first_name }}</span>
                        <span class="has-text-grey is-size-5 has-text-weight-normal"> / {{ user.email }}</span>
                      </router-link>
                    </div>
                  </div>
                </div>
                <div
                  class="column is-narrow has-text-right">
                  <button
                    class="button is-circle is-action"
                    @click="deleteUser(i)">
                    <i class="fal fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="tab === 'PROGRAMS'">
          <tabs
            :links="mandattabList"
            :current-tab="tabs"
            @changeView="tabs = $event"
            mode="emitter"
            class="is-border-bottom"></tabs>
          <div
            v-if="tabs === 'MANDATS_LIST_VUE'"
            class="">
            <table
              class="table is-fullwidth is-striped-v is-first-fixed-medium is-last-fixed-medium is-marginless has-cells-vcentered"
              v-if="all_access.length > 0">
              <thead>
                <tr class="is-size-6">
                  <th></th>
                  <th>
                    Programme
                  </th>
                  <th>Date d'ajout</th>
                </tr>
              </thead>
              <mandat-vue
                v-for="(a, i) in all_access"
                :key="i"
                :accesses="all_access"
                :allotments="a.lots"
                :selected-access="selectedAccess"
                @selectedAccess="val => selectedAccess = val"
                :agence="agence"
                :source="a"
                @afterdelete="afterDelete"
                :from-agence="true">
              </mandat-vue>
            </table>
            <pagination
              class="has-background-transparent"
              :loading="false"
              :current-page="currentAccessPage"
              :total-page="currentAccessTotalPage"
              @changePage="loadItems($event)" />
          </div>
          <div
            v-if="tabs === 'MANDATS_CREATE'">
            <mandat-form
              :agence-data="agence"
              @aftercreate="afterCreate"
              :from-agence="true">
            </mandat-form>
          </div>
        </div>
        <div
          v-else-if="tab === 'INFO'"
          class="">
          <div
            class="is-padding">
            <div class="w50">
              <r-label
                label="Nom du agence"
                for="name"
                :is-required="false"></r-label>
              <v-input
                id="name"
                name="name"
                :model="newName"
                @input="val => newName = val"
                v-validate="'required|min:2'"
                :errors-bag="errors"
                data-vv-value-path="val"
                data-vv-as="Nom de l'agence">
              </v-input>
            </div>
          </div>
          <submit-sticky-buttons
            v-if="newName && newName !== agence.name"
            :cancel="cancel"
            @submit="save"
            :loading="submitLoading"></submit-sticky-buttons>
        </div>
      </div>
    </page-content>
  </div>
</template>

<script>
import { Quickview, Sort } from '@/mixins'
import { mapGetters, mapState } from 'vuex'
// import { findIndex } from 'lodash'

const REMUNERATION_MODES = Object.freeze({
  PROGRAM: 'PROGRAM',
  CUSTOM: 'CUSTOM'
})

export default {
  name: 'AgenceVue',
  components: {
    MandatVue: () => import('@/components/mandat/MandatVue'),
    MandatForm: () => import('@/components/mandat/MandatForm')
  },
  mixins: [Quickview, Sort],
  props: {
    accessPk: {
      type: String
    },
    sourceAccess: {
      type: Object
    }
  },
  data () {
    return {
      submitLoading: false,
      newName: false,
      agence: null,
      users: [],
      // service: 'MANDAT',
      loading: false,
      tab: 'MEMBRES',
      tabs: 'MANDATS_LIST_VUE',
      programsCurrent: null,
      programsChoosen: [],
      programsAccess: [],
      access: {},
      programLots: [],
      allotments: null,
      newAllotments: null,
      REMUNERATION_MODES,
      remunerationMode: null,
      program: {},
      all_access: null,
      total_access: null,
      allotmentList: null,
      selectedAccess: null,
      editAccess: false,
      currentAccessPage: 1,
      currentAccessTotalPage: 0
    }
  },
  computed: {
    ...mapState(['quickview', 'currentUser']),
    ...mapGetters(['isManager', 'isAdmin', 'isPromoteur', 'canAddUsers']),
    /**
      * pk of the agence
      * @return {string}
      */
    canalPk () {
      return this.$route.params.id
    },
    /**
      * tabs
      * @return {array}
      */
    canalTabLinks () {
      let tab = [{ label: 'Membres', link: 'MEMBRES' }, { label: 'Programmes', link: 'PROGRAMS' }, { label: 'Informations', link: 'INFO' }]
      return tab
    },
    mandattabList () {
      let tabs = []
      tabs.push({ label: `${this.total_access} Programme(s)`, link: 'MANDATS_LIST_VUE' })
      if (this.isPromoteur && this.isAdmin) {
        tabs.push({ label: `Ajouter un programme`, link: 'MANDATS_CREATE' })
      }
      return tabs
    }
  },
  watch: {
    async quickview ({ mode, params, results }) {
      if (results) {
        if (mode === 'USER_SELECTION') {
          let userToAdd = []
          for (let user of results.entities) {
            let { data } = await this.$api.axios.get('agence')
            let channels = data.items
            let userUsed = []
            for (let channel of channels) {
              channel.users.forEach(x => userUsed.push(x.pk))
            }
            // check user
            if (userUsed.includes(user.pk)) {
              this.$toasted.global.danger(`Le vendeur : ${user.name} est déjà présent dans une agence`)
            } else {
              userToAdd.push(user)
            }
          }
          if (userToAdd.length > 0) {
            this.addUsers(userToAdd)
            this.$toasted.global.success('Utilisateur(s) ajouté(s) au agence')
          }
        }
      }
    },
    'programsChoosen' (v) {
      this.programsCurrent = v
      this.allotments = null
    }
  },
  created () {
    this.init()
  },
  methods: {
    /**
      * init vue
      * get agence and set name
      */
    async init () {
      await this.getAgence()
      await this.getAgenceAccess()
      await this.getAllotment()
    },
    /**
      * cancel new name
      */
    cancel () {
      this.$set(this, 'newName', this.agence.name)
    },
    /**
      * get agence
      */
    async getAgence () {
      this.loading = true
      try {
        let { data } = await this.$api.getOne(this.$resources.AGENCE, this.canalPk)
        this.agence = data
        this.loading = false
        this.users = this.agence.users
        this.$set(this, 'newName', this.agence.name)
      } catch (err) {
        console.log(err)
        this.loading = false
      }
    },
    /**
      * get mandat
      */
    // async getAgenceAccess () {
    //   this.loading = true
    //   try {
    //     let payload = {
    //       agence: this.canalPk
    //     }
    //     let { data } = await this.$api.get(this.$resources.AGENCE_ACCESS, payload)
    //     this.all_access = data.items
    //     this.loading = false
    //   } catch (err) {
    //     console.log(err)
    //     this.loading = false
    //   }
    // },
    async getAgenceAccess (page = 1, perPage = 50) {
      let accessParams = { agence: this.canalPk, page, per_page: perPage }
      try {
        let { data } = await this.$api.get(this.$resources.AGENCE_ACCESS, accessParams)
        this.all_access = data.items
        this.total_access = data.total
        this.accessesCount = data.count
        this.currentAccessPage = data.page
        this.currentAccessTotalPage = data.pages
      } catch (e) {
        console.log(e)
        this.loading = false
      }
    },
    loadItems (page) {
      this.getAgenceAccess(page)
    },
    /**
      * get allotment
      */
    async getAllotment () {
      let params = { sales_channel: this.canalPk }
      try {
        let { data } = await this.$api.get(this.$resources.ALLOTMENT_ALL, params)
        this.allotmentList = data.all_allotment
      } catch (e) {
        console.log(e)
      }
    },
    /**
      * after post mandat
      */
    async afterCreate (mandatdata) {
      this.all_access.push(mandatdata)
      this.tabs = 'MANDATS_LIST_VUE'
    },
    /**
      * after delete mandat
      */
    async afterDelete (mandatpk) {
      await this.getAgenceAccess()
    },
    /**
      * save agence name
      */
    async save () {
      // let agence = Object.assign({}, this.agence)
      let agence = { 'pk': this.agence.pk, 'name': this.agence.name }
      if (this.newName) {
        agence.name = this.newName
        for (let user of this.agence.users) {
          user.current_agence = this.newName
          try {
            await this.$api.put(this.$resources.USER, user.pk, user)
          } catch (err) {
            console.log(err)
          }
        }
      }
      this.submitLoading = true
      try {
        await this.$api.put(this.$resources.AGENCE, this.canalPk, agence)
        this.submitLoading = false
        this.$toasted.global.success('Modification de l\'agence enregistrée')
        this.getAgence()
      } catch (err) {
        console.log(err)
        this.submitLoading = false
      }
    },
    /**
      * prepar algolia params then
      * open new user quickview
      */
    openAddNewMember (type = 'multiple') {
      let params
      if (this.isAdmin && this.isPromoteur) {
        params = {
          searchKeys: ['USER'],
          facets: {
            USER: [
              [`pk:-${this.currentUser.pk}`]
            ],
            ACCOUNT: []
          },
          selectType: type,
          mode: 'store'
        }
      } else {
        params = {
          facets: {
            USER: [
              [`pk:-${this.currentUser.pk}`]
            ]
          },
          selectType: type,
          mode: 'store'
        }
      }

      if (this.isManager) {
        params.facets.USER.push([`manager.pk:${this.currentUser.pk}`])
      }
      this.openUserSelectionQuickview(params)
    },
    /**
    * Add user in agence
    */
    async addUsers (allUser) {
      let agenceAccounts = []
      this.agence.users.forEach(user => { agenceAccounts.push(user.pk) })
      for (let i of allUser) {
        agenceAccounts.push(i.pk)
        let user = i
        // user.current_agence = this.agence.name
        user.current_agence = {
          pk: this.agence.pk,
          name: this.agence.name
        }
        try {
          await this.$api.put(this.$resources.USER, i.pk, user)
        } catch (err) {
          console.log(err)
        }
      }
      this.agence.users = agenceAccounts
      let agence = Object.assign({}, this.agence)
      this.submitLoading = true
      try {
        await this.$api.patch(this.$resources.AGENCE, this.canalPk, agence)
        this.submitLoading = false
        // this.$toasted.global.success('Utilisateur ajouté au agence')
        this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
        this.getAgence()
      } catch (err) {
        console.log(err)
        this.submitLoading = false
      }
    },
    /**
      * Delete user in agence
      */
    async deleteUser (index) {
      let value = await this.confirmDelete()
      if (value.dismiss) return false
      if (value) {
        let accountsPk = []
        let userToDelete = this.agence.users[index]
        this.agence.users.forEach(user => { accountsPk.push(user.pk) })
        this.agence.users = accountsPk
        let agence = Object.assign({}, this.agence)
        agence.users.splice(index, 1)
        this.submitLoading = true
        try {
          await this.$api.patch(this.$resources.AGENCE, this.canalPk, agence)
          this.submitLoading = false
          this.$toasted.global.success('Utilisateur supprimé de l\'agence')
          this.getAgence()
        } catch (err) {
          console.log(err)
          this.submitLoading = false
        }
        try {
          userToDelete.current_agence = null
          await this.$api.put(this.$resources.USER, userToDelete.pk, userToDelete)
        } catch (err) {
          console.log(err)
        }
      }
    },
    /**
      * Confirm modal user
      */
    confirmDelete () {
      return this.$swal({
        title: 'Retirer utilisateur de l\'agence',
        text: 'L\'utilisateur ne sera plus rattaché à cette agence. Les statistiques de l\'agence seront actualisées avec ce nouveau paramètre.',
        focusConfirm: false,
        customClass: {
          confirmButton: 'is-danger'
        }
      })
    },
    /**
      * Delete agence
      */
    async removeCanal () {
      let value = await this.confirmDeleteCanal()
      if (value.dismiss) return false
      if (value) {
        this.loading = true
        try {
          await this.$api.delete(this.$resources.AGENCE, this.canalPk)
          this.$toasted.global.success('Suppression de l\'agence réussi')
          this.$router.push({ name: 'AgenceListVue' })
        } catch (e) {
          this.$toasted.global.danger('Erreur lors de la suppression')
        }
      }
      for (let user of this.agence.users) {
        user.current_agence = null
        try {
          await this.$api.put(this.$resources.USER, user.pk, user)
        } catch (err) {
          console.log(err)
        }
      }
    },
    /**
      * Confirm modal agence
      */
    async confirmDeleteCanal () {
      return this.$swal({
        title: 'Suppression de l\'agence',
        text: 'L\'agence sera supprimée définitivement',
        confirmButtonText: 'Supprimer',
        focusConfirm: false,
        customClass: {
          confirmButton: 'is-danger'
        }
      })
    }
  }
}
</script>
